import { render, staticRenderFns } from "./PreviewAndPublish.vue?vue&type=template&id=027d7322&"
import script from "./PreviewAndPublish.vue?vue&type=script&lang=ts&"
export * from "./PreviewAndPublish.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewAndPublish.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports